module.exports = __webpack_public_path__ + "static/media/bg_image.cccd2f58.jpg";